import React from 'react'
import Page from '../../layouts/Page'
import Container from './Container'
import { FormattedMessage } from 'react-intl'

const Influencers = () => {

  return (
    <Page
      title={<FormattedMessage id="my_influencers" defaultMessage={"My Influencers"} />}
      breadcrumbs={[
        {
          title: <FormattedMessage id="influencee" defaultMessage={"influencee"} />,
          link: "/"
        },
        {
          title: <FormattedMessage id="my_influencers" defaultMessage={"My Influencers"} />,
          link: "/influencers"
        },
        
      ]}
    >
      <Container />
    </Page>
  )
}

export default Influencers